import {AbstractControl, ValidationErrors} from '@angular/forms';
import {Utils} from '@astek/utils';

export function createdDateRangeValidator(control: AbstractControl): ValidationErrors | null {
  const createdAtFromControl: AbstractControl<Date | null> | null = control.get('createdAtFrom');
  const createdAtToControl: AbstractControl<Date | null> | null = control.get('createdAtTo');
  if (Utils.isNull(createdAtFromControl) || Utils.isNull(createdAtToControl)) {
    return null;
  }
  switch (true) {
    case Utils.isNull(createdAtFromControl.value) && Utils.isNull(createdAtToControl.value):
      createdAtFromControl.setErrors(null);
      createdAtToControl.setErrors(null);
      break;
    case Utils.isNull(createdAtFromControl.value):
      createdAtFromControl.setErrors({incorrect: true});
      break;
    case Utils.isNull(createdAtToControl.value):
      createdAtToControl.setErrors({incorrect: true});
      break;
    case Utils.isNotNull(createdAtFromControl.value) && Utils.isNotNull(createdAtToControl.value) &&
    createdAtToControl.value < createdAtFromControl.value:
      createdAtToControl.setErrors({incorrect: true});
      break;
    default:
      createdAtFromControl.setErrors(null);
      createdAtToControl.setErrors(null);
  }
  return null;
}
